var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions/bonus/subscribeCampaignAction';
var initialState = {
    data: [],
    subscribeStatus: undefined,
    isSubscribing: undefined,
    subcriptionError: undefined
};
export default function bonus(state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case Actions.FETCH_SUBSCRIBE_STATUS:
            return __assign(__assign({}, state), { isSubscribing: true });
        case Actions.SUCCESS_FETCH_SUBSCRIBE_STATUS:
            if (action.data && action.data.Error === undefined) {
                return __assign(__assign({}, state), { isSubscribing: false, data: action.data || [], subcriptionError: undefined });
            }
            else if (action.data.error) {
                return __assign(__assign({}, state), { isSubscribing: false, data: [], subcriptionError: action.data.error });
            }
            else {
                return __assign(__assign({}, state), { isSubscribing: false, data: [], subcriptionError: -100 });
            }
            return state;
        case Actions.SUCCESS_CREATE_SUBSCRIBE_CAMPAIGN:
            if (action.data.error === undefined) {
                return __assign(__assign({}, state), { subscribeStatus: 0, subcriptionError: undefined });
            }
            else {
                return __assign(__assign({}, state), { subcriptionError: action.data.error, subscribeStatus: undefined });
            }
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bonus/bonusReducer.js